<template>
  <b-container fluid>
    <b-spinner v-if="!loaded && loading" big label="Loading..."></b-spinner>
    <div v-else-if="loaded">
      <b-row no-gutters>
        <b-col md="12" class="text-right">
          <b-button variant="primary" @click="addPrepaid">Dodaj przedpłatę</b-button>
        </b-col>
      </b-row>
      <b-row no-gutters>
        <b-col cols="12" v-for="item in items" :key="item.id">
          <item :item="item" @delete="onDelete" />
        </b-col>
      </b-row>
    </div>
    <add-prepaid-modal ref="addPrepaidModal" @prepaid-added="getData()" :userId="id"></add-prepaid-modal>
  </b-container>
</template>

<script>
import { axios, eventBus } from "@/_infrastructure";
import item from "./DetailsPrepaidsItem";
import AddPrepaidModal from "./AddPrepaidModal";

export default {
  components: { item, AddPrepaidModal },
  name: "paymentList",
  data() {
    return {
      items: [],
      loading: false,
      loaded: false
    };
  },
  mounted() {
    this.loading = true;
    this.getData();
  },
  props: ["id"],
  methods: {
    onDelete(guid) {
      this.$bvModal
        .msgBoxConfirm("Czy na pewno chcesz usunąć tę przedpłatę?")
        .then(answer => {
          if (answer) {
            return axios
              .delete("prepaids", {
                params: {
                  guid: guid
                }
              })
              .then(() => {
                eventBus.$emit("notify-success", "Usunięto poprawnie.");
                let index = this.items.findIndex(p => p.id === guid);
                this.items.splice(index, 1);
              })
              .catch(err => {
                eventBus.$emit("unhandled-error", err);
              });
          }
        });
    },
    addPrepaid() {
      this.$refs.addPrepaidModal.showModal(this.id);
    },
    getData() {
      this.loading = true;
      return axios
        .get("/students/prepaids", {
          params: {
            id: this.id
          }
        })
        .then(result => {
          this.items = result.data;
          this.loaded = true;
        })
        .catch(err => {
          eventBus.$emit("unhandled-error", err);
        })
        .then(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
button {
  margin-right: 3px;
  margin-bottom: 10px;
}
</style>

